import React from "react";
import { Confirmed, ArrowRight, Unconfirmed, CurrentUnconfirmed } from "./_Icon";
import "../Styles/_StatusInformation.css";
import { orderUtils } from "../Helpers/OderUtils";

const steps = [
    { label: "Ordered", status: "created" },
    { label: "Authorized", status: "authorized" },
    { label: "Processing", status: "processed" },
    { label: "Ship", status: "shipped" },
    { label: "Deliver", status: "delivered" }
];

const getStepClassName = (currentStepIndex, index, isLastStepCompleted) => {
    if (currentStepIndex > index || (isLastStepCompleted && index === steps.length - 1)) {
        return "step completed";
    } else if (currentStepIndex === index) {
        return "step active";
    } else {
        return "step";
    }
};

const getStepIcon = (currentStepIndex, index, isLastStepCompleted) => {
    if (currentStepIndex > index || (isLastStepCompleted && index === steps.length - 1)) {
        return <Confirmed fill="#00999e" />;
    } else {
        if(currentStepIndex == index){
            return <CurrentUnconfirmed stroke="#00999e"/>;
        }else{
            return <Unconfirmed stroke="lightgrey"/>;
        }
    }
};

const getProgressPercentage = (currentStepIndex, index, isLastStepCompleted) => {
    const statusPercentages = {
        completed: "100%",
        active: "22px",
        notStarted: "0"
    };

    if (currentStepIndex > index || (isLastStepCompleted && index === steps.length - 1)) {
        return statusPercentages.completed;
    } else if (currentStepIndex === index) {
        return statusPercentages.active;
    } else {
        return statusPercentages.notStarted;
    }
};

const getAdditionalProgressBarStatus = (currentStepIndex, index, isLastStepCompleted) => {
    const statusPercentages = {
        completed: "completed",
        active: "active",
        notStarted: "not-started"
    };

    if (currentStepIndex > index || (isLastStepCompleted && index === steps.length - 1)) {
        return statusPercentages.completed;
    } else if (currentStepIndex === index) {
        return statusPercentages.active;
    } else {
        return statusPercentages.notStarted;
    }
};

const StatusInformation = ({ currentLanguage, order }) => {
    if (orderUtils.orderIsCancelled(order) || orderUtils.orderIsFullyRefunded(order) || orderUtils.getItemsThatRequireShipping(order).length === 0) {
        return false;
    }

    const subOrders = order.sub_orders;

    const latestStatus = subOrders.reduce((latest, subOrder) => {
        const lastCompletedStatus = subOrder.order_statuses.filter(status => status.show && status.date).sort((a, b) => new Date(b.date) - new Date(a.date))[0];

        if (lastCompletedStatus && (!latest || new Date(lastCompletedStatus.date) > new Date(latest.date))) {
            return lastCompletedStatus;
        }
        return latest;
    }, null);

    const currentStepIndex = latestStatus ? steps.findIndex(step => step.status === latestStatus.status.toLowerCase()) + 1 : 0;
    const isLastStepCompleted = currentStepIndex >= steps.length;

    return (
        <div className="order-progress allow-focus" tabIndex="0">
            {steps.map((step, index) => (
                <div
                    key={index}
                    className={`${getStepClassName(currentStepIndex, index, isLastStepCompleted)} ${
                        index === currentStepIndex ||
                        index === currentStepIndex + 1 ||
                        (currentStepIndex === steps.length - 1 && index === currentStepIndex - 1) ||
                        (isLastStepCompleted && index === steps.length - 1)
                            ? "visible"
                            : "hidden"
                    }`}
                >
                    {getStepIcon(currentStepIndex, index, isLastStepCompleted)}
                    <div className="label">
                        {currentStepIndex === index
                            ? currentLanguage.ORDER_PAGE.STATUS_BAR_SECTION.STATUSES[step.status.toUpperCase()].ACTIVE
                            : currentLanguage.ORDER_PAGE.STATUS_BAR_SECTION.STATUSES[step.status.toUpperCase()].COMPLETED}
                    </div>
                    <div className="progress-bar-background">
                        <div className={`progress-bar ${getAdditionalProgressBarStatus(currentStepIndex, index, isLastStepCompleted)}`}>
                            {(currentStepIndex === index || (isLastStepCompleted && index === steps.length - 1)) && <div className="progress-circle"></div>}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default StatusInformation;



// WEBPACK FOOTER //
// ./src/views/Order/components/_StatusInformation.jsx